export { default as Dialog } from "./Dialog.svelte";
export { default as DialogTitle } from "./DialogTitle.svelte";
export { default as DialogOverlay } from "./DialogOverlay.svelte";
export { default as DialogDescription } from "./../description/Description.svelte";
